// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class HelpPlanVm {
    @AutoMap() hplId: string;
    @AutoMap() hplName: string;
    @AutoMap() hplCode: string;
    @AutoMap() hplIsInIntake: boolean;
    @AutoMap() helpPlanTypeIds: string[];
}
